import { render, staticRenderFns } from "./SeeCompanyDia.vue?vue&type=template&id=988e39f6&scoped=true"
import script from "./SeeCompanyDia.vue?vue&type=script&lang=js"
export * from "./SeeCompanyDia.vue?vue&type=script&lang=js"
import style0 from "./SeeCompanyDia.vue?vue&type=style&index=0&id=988e39f6&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988e39f6",
  null
  
)

export default component.exports